import { css } from '@emotion/react';

const limitInput = css`
  width: 196px;
`;
export default {
  limitInput,
};
